import { render } from "./ShowEditProfileComponent.vue?vue&type=template&id=0968bae0&scoped=true"
import script from "./ShowEditProfileComponent.vue?vue&type=script&lang=js"
export * from "./ShowEditProfileComponent.vue?vue&type=script&lang=js"
script.render = render
script.__scopeId = "data-v-0968bae0"

export default script